import React from "react";
import { Container } from "@mui/material";

function Slide(props) {
  const { slide, currentslide, index } = props;
  return (
    <Container maxWidth="lg">
      <div
        className={`slide ${currentslide === index ? "active" : "inactive"}`}
      >
        <div>
          <h3 data-aos="fade-right">
            <span>{slide.title}</span>
          </h3>
          <p className="graytext" data-aos="fade-right">
            <i className={"fad fa-" + slide.texticon}></i>
            <span>{slide.text}</span>
          </p>
        </div>
        <div data-aos="fade-left">
          <img src={slide.img} alt="" />
        </div>
      </div>
    </Container>
  );
}
export default Slide;
